import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Yuklanish paytida joy egallovchi blok — skeleton. Yakuniy tarkib bilan bir xil o'lchamda
 * chizilishi kerak, aks holda ma'lumot kelganda sahifa "sakraydi" (layout shift).
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-card bg-app-border/60', className)}
      {...props}
    />
  )
}
